<app-tourism-calendar-event-view
	[selectedObject]="selectedObject"
	[vehicles]="vehicles"
	[drivers]="allDrivers"
	[touristGuides]="allTouristGuides"
	[users]="users"
	[parameters]="parameters"
	(eventClosed)="eventClosed($event)"
></app-tourism-calendar-event-view>

<app-tourist-guides-calendar-filters
	userFilters="touristGuidesCalendar"
	[touristGuides]="allTouristGuides"
	[touristGuideTypes]="parameters.touristGuideTypes"
	(selected)="filtersSelected($event)"
></app-tourist-guides-calendar-filters>

<app-events-timeline
	[date_from]="date_from"
	[date_to]="date_to"
	[data]="data"
	addLink="/tourist-guides-event/add/"
	(filtersClicked)="filtersOpen()"
	(eventClicked)="eventOpen($event)"
></app-events-timeline>
